
import React from 'react';
import { Trophy, MessageCircle, Phone, Mail, Instagram, Facebook, Map, Target, QrCode } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const SportsLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Trophy,
      title: "Modalidades",
      subtitle: "Conheça nossos esportes",
      url: "https://decidedigital.com.br/",
      bgColor: "bg-orange-500 hover:bg-orange-600"
    },
    {
      icon: Target,
      title: "Inscrições",
      subtitle: "Faça parte do time",
      url: "https://decidedigital.com.br/",
      bgColor: "bg-green-500 hover:bg-green-600"
    },
    {
      icon: MessageCircle,
      title: "WhatsApp Esportes",
      subtitle: "Informações e treinos",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20esportes",
      bgColor: "bg-green-600 hover:bg-green-700"
    },
    {
      icon: Phone,
      title: "Contato",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      bgColor: "bg-blue-500 hover:bg-blue-600"
    },
    {
      icon: Mail,
      title: "E-mail",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      bgColor: "bg-purple-500 hover:bg-purple-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-100 to-red-100 py-8 px-4">
      <div className="max-w-md mx-auto">
        <div className="bg-white rounded-3xl p-6 shadow-xl mb-6 animate-fade-in">
          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center">
              <Trophy className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Centro Esportivo</h1>
            <div className="flex items-center justify-center gap-2">
              <Trophy className="w-4 h-4 text-orange-600" />
              <p className="text-gray-600 text-sm">Clube esportivo com diversas modalidades e instrutores qualificados.</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-4 shadow-md mb-6 text-center animate-scale-in">
          <div className="flex items-center justify-center gap-2 mb-3">
            <QrCode className="w-4 h-4 text-orange-600" />
            <p className="text-gray-700 text-sm">Modalidades e Horários:</p>
          </div>
          <QRCodeGenerator url="https://decidedigital.com.br/" size={100} />
        </div>

        <div className="flex justify-center space-x-4 mb-6">
          {socialLinks.map((social, index) => (
            <a key={index} href={social.url} target="_blank" rel="noopener noreferrer" 
               className={`w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md hover:shadow-lg link-button animate-scale-in animate-delay-${index * 100}`}>
              <social.icon className="w-5 h-5 text-orange-600" />
            </a>
          ))}
        </div>

        <div className="space-y-3">
          {mainLinks.map((link, index) => (
            <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" 
               className={`block w-full p-4 ${link.bgColor} rounded-2xl text-white shadow-lg link-button animate-fade-in animate-delay-${index * 100}`}>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                  <link.icon className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-lg">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-4 shadow-md mt-6 animate-fade-in">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Map className="w-4 h-4 text-orange-600" />
            <p className="text-gray-700 text-sm font-medium">Localização das Quadras:</p>
          </div>
          <MapComponent 
            latitude={-8.7619} 
            longitude={-63.9019} 
            zoom={16}
            category="sports"
            popupText="Centro Esportivo - Quadras e Instalações"
          />
        </div>
      </div>
    </div>
  );
};

export default SportsLinktree;
